export default __webpack_public_path__ + "static/media/wall-prat.3f33f2ac.JPG";